export default {"src":"/_next/static/media/better-decision-making-for-businesses.591e0f35.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};